import { ReservationDatepicker } from './reservation-datepicker';

type ReservationCalendarHeaderProps = {
  dateFrom: Date;
  dateTo: Date;
  selectedDate: Date;
  onDateChange: (dateFrom: Date, dateTo: Date, selectedDate?: Date) => void;
};

export const ReservationCalendarHeader = ({
  dateFrom,
  dateTo,
  selectedDate,
  onDateChange,
}: ReservationCalendarHeaderProps) => {
  return (
    <div className="w-full">
      <ReservationDatepicker
        dateFrom={dateFrom}
        dateTo={dateTo}
        selectedDate={selectedDate}
        onDateChange={onDateChange}
      />
    </div>
  );
};
